import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalGetHubCardDataDocument = gql`
  query SalesPortalGetHubCardData(
    $businessOrganizationUUID: uuid!
    $cardType: HubCardType!
    $userUUID: uuid!
    $userTimezone: String!
  ) {
    getHubCardData(
      analytics_type: $cardType
      business_organization_id: $businessOrganizationUUID
      user_id: $userUUID
      user_timezone: $userTimezone
    ) {
      card_data_json
    }
  }
`;
export function useSalesPortalGetHubCardDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalGetHubCardDataQuery,
    Types.SalesPortalGetHubCardDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalGetHubCardDataQuery,
    Types.SalesPortalGetHubCardDataQueryVariables
  >(SalesPortalGetHubCardDataDocument, options);
}
export function useSalesPortalGetHubCardDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalGetHubCardDataQuery,
    Types.SalesPortalGetHubCardDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalGetHubCardDataQuery,
    Types.SalesPortalGetHubCardDataQueryVariables
  >(SalesPortalGetHubCardDataDocument, options);
}
export type SalesPortalGetHubCardDataQueryHookResult = ReturnType<
  typeof useSalesPortalGetHubCardDataQuery
>;
export type SalesPortalGetHubCardDataLazyQueryHookResult = ReturnType<
  typeof useSalesPortalGetHubCardDataLazyQuery
>;
export type SalesPortalGetHubCardDataQueryResult = Apollo.QueryResult<
  Types.SalesPortalGetHubCardDataQuery,
  Types.SalesPortalGetHubCardDataQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalGetHubCardDataQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalGetHubCardDataQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalGetHubCardDataQuery,
    Types.SalesPortalGetHubCardDataQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalGetHubCardDataQuery,
    Types.SalesPortalGetHubCardDataQueryVariables
  >(SalesPortalGetHubCardDataDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalGetHubCardDataLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalGetHubCardDataLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalGetHubCardDataQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalGetHubCardDataQuery,
    Types.SalesPortalGetHubCardDataQueryVariables
  >(SalesPortalGetHubCardDataDocument, lazyOptions);
}
